// Which record the person has open, from the page's path (MOTHER-187), for the
// assistant's `viewing` hint on POST /api/assistant/messages (MOTHER-186). Pure:
// no React, no fetch, so it is unit tested (viewing.test.ts).
import { OBJECTS, type ObjectKey } from '../navigation';

/** The record a question is asked from: an object key and the record's id. */
export interface Viewing {
  object: ObjectKey;
  id: string;
}

const OBJECT_KEYS: ReadonlySet<string> = new Set(OBJECTS.map((o) => o.key));

// The server's isUuid: any 8-4-4-4-12 hex id.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The record a page shows, when the page is a record page: `/<object>/<id>`, with
 * `<object>` one of the app's objects (the keys the assistant accepts) and `<id>` a
 * UUID, optionally followed by `/related/<relation>`. Null for every other page:
 * a list, `/<object>/new`, an unknown object, an id that is not a UUID.
 * A query string or hash, if given, is ignored.
 */
export function viewingFrom(pathname: string): Viewing | null {
  const path = pathname.split(/[?#]/, 1)[0] ?? '';
  const segments = path.split('/').slice(1);
  if (segments.at(-1) === '' && segments.length > 1) segments.pop();
  const [object, id, related, relation, ...rest] = segments;
  if (object === undefined || id === undefined || !OBJECT_KEYS.has(object) || !UUID.test(id)) return null;
  if (related === undefined) return { object: object as ObjectKey, id };
  if (related !== 'related' || relation === undefined || relation === '' || rest.length > 0) return null;
  return { object: object as ObjectKey, id };
}
